import { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-toastify/dist/ReactToastify.css";
import 'react-tooltip/dist/react-tooltip.css'
import "../assets/css/menus.css";
// import "../assets/css/style.css";
import "../assets/css/newStyle.css";
import "../assets/css/media.css";
import store from "../stores";
import PizzaLoader from "./Common/PizzaLoader/PizzaLoader";

const MainRoutes = lazy(() => import("./Routers/MainRoutes"));

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<PizzaLoader />}>
          <MainRoutes />
        </Suspense>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
